module.exports = __webpack_public_path__ + "img/petstairs22.33818d5c.jpg";